import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import VideoServices from '../../services/videoServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('video/list', async (query, thunkAPI) => {
  try {
    const response = await VideoServices.getList(query);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListArchive = createAsyncThunk('video/getListArchive', async (query, thunkAPI) => {
  try {
    const response = await VideoServices.getListArchive(query);
    // Response structure dari axios: { data: { status, message, data: {...} } }
    // Service return response.data, jadi kita dapat { status, message, data: {...} }
    // Kita return langsung karena reducer akan handle
    return response;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('video/create', async (data, thunkAPI) => {
  try {
    const response = await VideoServices.create(data);
    thunkAPI.dispatch(getList());

    return response.data;
  } catch (error) {
    console.log(error);
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    if (error?.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const readData = createAsyncThunk('video/read', async (id, thunkAPI) => {
  try {
    const response = await VideoServices.read(id);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateData = createAsyncThunk('video/update', async ({ id, data }, thunkAPI) => {
  try {
    const response = await VideoServices.update(id, data);
    thunkAPI.dispatch(getList());

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteData = createAsyncThunk('video/delete', async (id, thunkAPI) => {
  try {
    const response = await VideoServices.del(id);
    thunkAPI.dispatch(getList());

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    if (error.response.status === 404) {
      thunkAPI.dispatch(getList());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const changeStatus = createAsyncThunk('video/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await VideoServices.changeStatus(data.id, data);
    thunkAPI.dispatch(getList());
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const addFile = createAsyncThunk('video/addFile', async ({ id, fileID }, thunkAPI) => {
  try {
    const response = await VideoServices.addFile(id, fileID);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const delFile = createAsyncThunk('video/delFile', async ({ id, fileID }, thunkAPI) => {
  try {
    const response = await VideoServices.delFile(id, fileID);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getQuestionPreview = createAsyncThunk('video/preview', async (id, thunkAPI) => {
  try {
    const response = await VideoServices.getQuestionPreview(id);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getSession = createAsyncThunk('video/getSession', async ({ id, sessionId }, thunkAPI) => {
  try {
    const response = await VideoServices.getSession(id, sessionId);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getQuestionList = createAsyncThunk('video/getQuestionList', async ({ id, page, perPage, sort, orderBy, search }, thunkAPI) => {
  try {
    const response = await VideoServices.getQuestionList(id, { page, perPage, sort, orderBy, search });
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const storeQuestion = createAsyncThunk('video/storeQuestion', async ({ id, data }, thunkAPI) => {
  try {
    const response = await VideoServices.storeQuestion(id, data);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getQuestion = createAsyncThunk('video/getQuestion', async ({ id, questionId }, thunkAPI) => {
  try {
    const response = await VideoServices.getQuestion(id, questionId);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateQuestion = createAsyncThunk('video/updateQuestion', async ({ id, questionId, data }, thunkAPI) => {
  try {
    const response = await VideoServices.updateQuestion(id, questionId, data);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const destroyQuestion = createAsyncThunk('video/destroyQuestion', async ({ id, questionId }, thunkAPI) => {
  try {
    const response = await VideoServices.destroyQuestion(id, questionId);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getRatings = createAsyncThunk('video/getRatings', async ({ id, page, perPage, sort, orderBy }, thunkAPI) => {
  try {
    const response = await VideoServices.getRatings(id, { page, perPage, sort, orderBy });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const getHistory = createAsyncThunk('video/getHistory', async ({ id, query }, thunkAPI) => {
  try {
    const response = await VideoServices.getHistory(id, query);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

const initialState = { isLoading: false, list: [], data: [], ratings: null, question: null, questions: null, group: [], error: [] };

const videoSlice = createSlice({
  name: 'video',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        // Payload structure: { status, message, data: { data: [...], total: ..., ... } }
        // Kita perlu mengambil action.payload.data karena response.data sudah di-extract di thunk
        if (action.payload && action.payload.data) {
          // Jika payload sudah memiliki structure { data: {...} }, gunakan langsung
          state.list = action.payload.data;
        } else if (action.payload && Array.isArray(action.payload.data)) {
          // Fallback untuk structure yang berbeda
          state.list = action.payload;
        } else {
          state.list = { data: [], total: 0 };
        }
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.errors?.length > 0 ? action.payload.errors : [];
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      }),
      builder.addCase(updateData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.errors?.length > 0 ? action.payload.errors : [];
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(addFile.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(addFile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(addFile.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(delFile.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(delFile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = [];
      }),
      builder.addCase(delFile.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getRatings.pending, (state) => {
        state.isLoading = true;
        state.ratings = null;
      }),
      builder.addCase(getRatings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ratings = action.payload;
      }),
      builder.addCase(getRatings.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getHistory.pending, (state) => {
        state.isLoading = true;
        state.data = null;
        state.group = [];
      }),
      builder.addCase(getHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.group = action.payload.session;
      }),
      builder.addCase(getHistory.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getQuestionPreview.pending, (state) => {
        state.isLoading = true;
        state.data = null;
        state.questions = null;
      }),
      builder.addCase(getQuestionPreview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.questions = action.payload.question;
      }),
      builder.addCase(getQuestionPreview.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getSession.pending, (state) => {
        state.isLoading = true;
        state.data = null;
        state.questions = null;
        state.session = null;
      }),
      builder.addCase(getSession.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data;
        state.questions = action.payload?.question;
        state.session = action.payload?.session;
      }),
      builder.addCase(getSession.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getQuestionList.pending, (state) => {
        state.isLoading = true;
        state.data = null;
        state.questions = null;
      }),
      builder.addCase(getQuestionList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.video;
        state.questions = action.payload?.question;
      }),
      builder.addCase(getQuestionList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(storeQuestion.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(storeQuestion.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(storeQuestion.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.errors?.length > 0 ? action.payload.errors : [];
      }),
      builder.addCase(getQuestion.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getQuestion.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data;
        state.question = action.payload?.question;
      }),
      builder.addCase(getQuestion.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateQuestion.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateQuestion.fulfilled, (state, action) => {
        state.isLoading = false;
        state.question = action.payload;
      }),
      builder.addCase(updateQuestion.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.errors?.length > 0 ? action.payload.errors : [];
      }),
      builder.addCase(destroyQuestion.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(destroyQuestion.fulfilled, (state) => {
        state.isLoading = false;
        state.data = null;
      }),
      builder.addCase(destroyQuestion.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = videoSlice;
export default reducer;
